import React from "react";

const Index = () => {
  return <div>Dashboard</div>;
};

export default Index;
